import React, { useEffect, useState } from "react";
import { MenuItem, FormControl, Select, Chip } from "@mhome/ui";
import { alpha } from "@mui/material/styles";
import { fixedSelectCheck } from "./fixed-select-check";
const FixedSelectInput = ({
  valueSpec,
  onChange,
  onError,
  multiSelect = false,
  menuDirection = "auto",
  zIndex = 100,
}) => {
  const [value, setValue] = useState(multiSelect ? [] : null);
  const [error, setError] = useState(null);
  const [enums, setEnums] = useState([]);
  const [enumLabels, setEnumLabels] = useState([]);
  const isReadOnly = valueSpec.readOnly;

  useEffect(() => {
    setValue(valueSpec.value);
    setEnums(valueSpec.enums || []);
    setEnumLabels(valueSpec.enumLabels || []);
    const err = checkValue(valueSpec.value, valueSpec);
    if (err) {
      setError(true);
      onError(true);
    }
    return () => {};
  }, [valueSpec]);

  const checkValue = (value, spec) => {
    if (multiSelect) {
      for (let i = 0; i < value.length; i++) {
        const err = !fixedSelectCheck(value[i], spec);
        if (err) {
          return err;
        }
      }
      return false;
    } else {
      const err = !fixedSelectCheck(value, spec);
      return err;
    }
  };

  const handleChange = (e) => {
    if (isReadOnly) return;
    const err = !fixedSelectCheck(e.target.value, valueSpec);
    setValue(e.target.value);
    setError(err);
    if (err) {
      onError();
    } else {
      onChange(e.target.value);
    }
  };

  // Helper function to get display label for a value
  const getDisplayLabel = (enumValue) => {
    if (!enumLabels || enumLabels.length === 0) return enumValue;
    const enumIndex = enums.indexOf(enumValue);
    return enumIndex >= 0 && enumIndex < enumLabels.length
      ? enumLabels[enumIndex]
      : enumValue;
  };

  return (
    <FormControl
      fullWidth
      className="w-full h-full relative"
      style={{
        opacity: isReadOnly ? 0.6 : 1,
        zIndex,
      }}
    >
      {value !== null && (
        <Select
          value={value}
          onChange={handleChange}
          multiple={multiSelect}
          error={error}
          disabled={isReadOnly}
          displayEmpty
          className="w-full h-full rounded-lg"
          style={{
            zIndex,
          }}
          renderValue={(selected) =>
            selected ? (
              multiSelect ? (
                <div className="flex flex-wrap gap-1">
                  {selected.map((value) => (
                    <Chip
                      key={value}
                      label={getDisplayLabel(value)}
                      className="h-5 rounded text-xs"
                      style={{
                        backgroundColor: "hsl(var(--primary) / 0.1)",
                        color: "hsl(var(--primary))",
                        padding: "0 6px",
                      }}
                    />
                  ))}
                </div>
              ) : (
                getDisplayLabel(selected)
              )
            ) : (
              <div className="text-secondary text-sm">
                {multiSelect ? "Select values" : "Select a value"}
              </div>
            )
          }
        >
          {enums.map((option) => (
            <MenuItem
              key={option}
              value={option}
              className="min-h-auto py-2 px-4"
            >
              {getDisplayLabel(option)}
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default FixedSelectInput;
